import { Skeleton } from "@mui/material";

const OversightSectionsSkeleton = () => {
  return (
    <div className="row">
      <div className="col-12 col-md-6 p-0 ">
        <Skeleton
          variant="rectangle"
          width="98%"
          height={700}
          className="mx-auto mt-2 mb-2"
          style={{ borderRadius: 4 }}
        />
      </div>
      <div className="col-12 col-md-6 p-0 ">
        <Skeleton
          variant="rectangle"
          width="98%"
          height={700}
          className="mx-auto mt-2 mb-2"
          style={{ borderRadius: 4 }}
        />
      </div>
    </div>
  );
};

export default OversightSectionsSkeleton;
